import { Injectable } from '@angular/core';
import { GoogleGenerativeAI } from "@google/generative-ai";

@Injectable({
  providedIn: 'root'
})
export class GeminiApiService {
  private ai;

  constructor() {
    this.ai = new GoogleGenerativeAI("AIzaSyA9S_gNVu2Ay6o3g7Wdis9pUoYmDTZvgqQ");
  }

  /*async generateContent(prompt: string, image: any): Promise<string> {
    try {
      const response = await this.ai.models.generateContent({
      model: "gemini-2.5-flash",
      contents: [
        //createUserContent([
          //prompt,
          //createPartFromUri(image.uri, image.mimeType)
        //]),
        image,
        { text: prompt }
      ],
      config: {
        responseMimeType: "application/json",
      },
    });
      return response.text;
    } catch (error) {
      console.error("Error generating content:", error);
      throw error;
    }
  }*/

  async generateContent(prompt: string, image: any): Promise<string> {
    try {
      // 1. Obtener el modelo correctamente (1.5-flash es el estándar actual para esto)
      const model = this.ai.getGenerativeModel({
        model: "gemini-1.5-flash",
        generationConfig: {
          responseMimeType: "application/json",
          // Definimos el esquema como un objeto plano para evitar errores de Type.STRING
          /*responseSchema: {
            type: "object",
            properties: {
              NIT: { type: "string" },
              factura: { type: "number" },
              cuf: { type: "string" },
              date: { type: "string" },
              codigo_cliente: { type: "string" },
              productos: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    codigo: { type: "string" },
                    quantity: { type: "number" },
                    descripcion: { type: "string" },
                    unitPrice: { type: "number" },
                    total: { type: "number" }
                  }
                }
              }
            }
          }*/
        } as any // El 'as any' es vital para que Angular 17 no se queje de las propiedades
      });

      // 2. Ejecutar la generación. 
      // 'image' debe venir en formato: { inlineData: { data: 'BASE64', mimeType: 'image/jpeg' } }
      const result = await model.generateContent([prompt, image]);
      const response = await result.response;
      
      return response.text(); 
    } catch (error) {
      console.error("Error al procesar la factura con IA:", error);
      throw error;
    }
  }

  async leerCarnetDeIdentidad(prompt: string, image: any): Promise<string> {
    try {
      // 2. Definir el modelo con la configuración del esquema
      const model = this.ai.getGenerativeModel({
        model: "gemini-1.5-flash", // Nota: Usa nombres de modelos existentes como 1.5-flash
        generationConfig: {
          responseMimeType: "application/json",
          responseSchema: {
            type: "object", // Cambiamos Type por SchemaType
            properties: {
              document_type: { type: "string" },
              country: { type: "string" },
              id_number: { type: "string" },
              first_names: { type: "string" },
              last_names: { type: "string" },
              date_of_birth: { type: "string" },
              date_of_issue: { type: "string" },
              date_of_expiration: { type: "string" },
              photo: { type: "string" }
            }
          }
        } as any
      });

      // 3. Pasar los contenidos correctamente
      // El objeto 'image' debe tener la estructura { inlineData: { data: 'base64', mimeType: '...' } }
      const result = await model.generateContent([prompt, image]);
      const response = await result.response;
      
      return response.text(); 
    } catch (error) {
      console.error("Error generating content:", error);
      throw error;
    }
  }

  async leerPlanillaPartido(prompt: string, image: any): Promise<string> {
  try {
    // 1. Obtener el modelo con la configuración de esquema JSON
    const model = this.ai.getGenerativeModel({
      model: "gemini-1.5-flash", // Modelo estable para visión y JSON
      generationConfig: {
        responseMimeType: "application/json",
        responseSchema: {
          type: "object", // Usamos strings para evitar el error TS2305
          properties: {
            match_details: { type: "string" },
            team_a: {
              type: "object",
              properties: {
                name: { type: "string" },
                codigo: { type: "string" },
                marcador_final: { type: "string" },
                trajo_balon: { type: "boolean" },
                trajo_cintillo: { type: "boolean" },
                jugadores: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      codigo: { type: "string" },
                      nombre: { type: "string" },
                      numero: { type: "string" },
                      total_goles: { type: "number" },
                      tarjeta_amarilla: { type: "boolean" },
                      tarjeta_roja: { type: "boolean" }
                    }
                  }
                }
              }
            },
            team_b: {
              type: "object",
              properties: {
                name: { type: "string" },
                codigo: { type: "string" },
                marcador_final: { type: "string" },
                jugadores: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      codigo: { type: "string" },
                      nombre: { type: "string" },
                      numero: { type: "string" },
                      total_goles: { type: "number" },
                      tarjeta_amarilla: { type: "boolean" },
                      tarjeta_roja: { type: "boolean" }
                    }
                  }
                }
              }
            }
          }
        }
      } as any // Evita errores de propiedades conocidas en v17
    });

    // 2. Generar el contenido (Asegúrate de que 'image' sea el objeto inlineData)
    const result = await model.generateContent([prompt, image]);
    const response = await result.response;
    
    return response.text(); 
  } catch (error) {
    console.error("Error procesando planilla de partido:", error);
    throw error;
  }
}
}
